/**
 * Cloudflare Turnstile for the storefront forms (part request, support ticket).
 * Megabox Central refuses these forms without a valid token, so no secret key
 * ever lives in the page. Site key: Theme settings → Spam protection.
 *
 *   mbsTurnstile.render(container, siteKey) → Promise<widgetId | null>
 *   mbsTurnstile.token(widgetId)            → token string ('' when not solved)
 *   mbsTurnstile.reset(widgetId)            → fresh challenge (tokens are single-use)
 */
(function () {
  'use strict';
  if (window.mbsTurnstile) return;

  var loading = null;

  function load() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = function () {
        if (window.turnstile) resolve(window.turnstile);
        else reject(new Error('Turnstile unavailable'));
      };
      script.onerror = function () {
        loading = null;
        reject(new Error('Turnstile failed to load'));
      };
      document.head.appendChild(script);
    });
    return loading;
  }

  // The forms sit below the fold: start the challenge when the visitor gets
  // there, not on page load.
  function whenVisible(el) {
    if (!('IntersectionObserver' in window)) return Promise.resolve();
    return new Promise(function (resolve) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          observer.disconnect();
          resolve();
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(el);
    });
  }

  window.mbsTurnstile = {
    render: function (container, siteKey) {
      if (!container || !siteKey) return Promise.resolve(null);
      return Promise.all([load(), whenVisible(container)])
        .then(function (results) {
          var turnstile = results[0];
          var retried = false;
          var id = turnstile.render(container, {
            sitekey: siteKey,
            size: 'flexible',
            'error-callback': function () {
              // 600xxx challenge failures are retryable: one automatic retry,
              // after that Cloudflare shows its own message.
              if (retried) return false;
              retried = true;
              setTimeout(function () { turnstile.reset(id); }, 1000);
              return true;
            }
          });
          return id;
        })
        .catch(function () {
          return null;
        });
    },
    token: function (widgetId) {
      if (widgetId == null || !window.turnstile) return '';
      return window.turnstile.getResponse(widgetId) || '';
    },
    reset: function (widgetId) {
      if (widgetId != null && window.turnstile) window.turnstile.reset(widgetId);
    }
  };
})();
